
const admins = [
    "AdminUser"
];

export default admins;
